import { useCallback, useState } from 'react'

export const useGenerateLorModalController = () => {
	const [isOpen, setIsOpen] = useState(false)
	const [application, setApplication] = useState(null)

	const open = useCallback(row => {
		setApplication(row)
		setIsOpen(true)
	}, [])

	const close = useCallback(() => {
		setIsOpen(false)
		setApplication(null)
	}, [])

	return {
		isOpen,
		application,
		open,
		close,
	}
}
